import React from "react";
import { Link } from "react-router-dom";
import RightArrow from "../SVG";

import blogBG from "../../assets/img/blog/bg-1.jpg";
import Image from "../../assets/img/blog/blog-1-1.jpg";

const SingleBlog = (props) => {
  const {
    isFromMember = false,
    itemClass,
    blogImage,
    publishedDate,
    commentCount,
    heading,
    title,
    btnClass,
    btnText,
    hasArrow,
    _id,
    status,
    type = "event",
  } = props;

  const detailLink =
    type === "news"
      ? `/news-details?id=${_id}&&title=${heading}`
      : `/event-details?id=${_id}&&title=${heading}`;

  return (
    <div
      className="it-blog-item-box h-[440px]"
      style={{ backgroundImage: `url(${blogBG})` }}
    >
      <div className={itemClass ? itemClass : "it-blog-item"}>
        <div className="it-blog-meta pb-15">
          <span>
            <i className="fa-solid fa-calendar-days"></i>
            {publishedDate ? publishedDate : "14 June 2023"}
          </span>
        </div>
        <h4 className="">
          <Link to={detailLink}>{heading}</Link>
        </h4>
        {isFromMember && (
          <span
            className={`inline-flex mb-1 items-center rounded-full px-3 py-1 text-sm font-medium shadow-sm
      ${
        status === "approved"
          ? "bg-green text-white ring-1 ring-green-200"
          : status === "rejected"
          ? "bg-red text-white ring-1 ring-red-200"
          : status === "pending"
          ? "bg-yellow-50 text-yellow-700 ring-1 ring-yellow-200"
          : "bg-gray-50 text-gray-700 ring-1 ring-gray-200"
      }`}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        )}
        {type === "event" ? (
          <div className="it-about-text line-clamp-2 truncate">
            <p>{title}</p>
          </div>
        ) : (
          <div
            style={{ maxHeight: "15rem" }}
            className="event-description-content   mb-3"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}

        <Link className={btnClass ? btnClass : "ed-btn-blog"} to={detailLink}>
          {btnText ? btnText : "read more"}
          {hasArrow && (
            <i>
              <RightArrow />
            </i>
          )}
        </Link>
      </div>
    </div>
  );
};

export default SingleBlog;
